var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFranceLotoPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 6.35,
    y1: 11.92,
    x2: 6.48,
    y2: 4.81,
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#417cbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#4982c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#6091c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#85abd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b9cee7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fafbfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 20.46,
    y1: 12.98,
    x2: 20.46,
    y2: 0.78,
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#ed1c2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#ee2432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ef3b47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f2606a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#f6949a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fcd5d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 37.49,
    y1: 12.27,
    x2: 36.31,
    y2: 3.45,
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#417cbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#4982c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6091c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#85abd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b9cee7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fafbfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 50.66,
    y1: 13.25,
    x2: 49.13,
    y2: 5.98,
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ed1c2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ee2432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ef3b47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#f2606a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#f6949a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fcd5d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 6.66,
    cy: 11.07,
    r: 6.35,
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#417cbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3e75bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#3562ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#3562ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3460ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#3159a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#2a4e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#233f93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 20.42,
    cy: 9.96,
    r: 9.48,
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#eb1c2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#e41e28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#e21e28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#db1e27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#d01d25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#bf1d23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#a91c20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#961b1e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 36.71,
    cy: 11.21,
    r: 7.94,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 49.88,
    cy: 11.87,
    r: 6.14,
    xlinkHref: "#c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.14 22.818a6.167 6.167 0 1 1-6.13 6.167 6.149 6.149 0 0 1 6.13-6.167z",
    fill: "#233f93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14 23.122a5.864 5.864 0 1 1-5.827 5.864 5.845 5.845 0 0 1 5.827-5.864z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.292 25.092a4.013 4.013 0 0 1 0 .469 4.391 4.391 0 0 1-8.781.092 5.633 5.633 0 0 1 8.754-.562z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.806 18.796A9.205 9.205 0 1 1 11.693 28a9.15 9.15 0 0 1 9.113-9.205z",
    fill: "#961b1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.806 19.219A8.754 8.754 0 1 1 12.135 28a8.717 8.717 0 0 1 8.671-8.781z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.801 21.419a7.705 7.705 0 1 1-7.658 7.695 7.668 7.668 0 0 1 7.658-7.695z",
    fill: "#233f93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.801 21.787a7.364 7.364 0 1 1-7.29 7.364 7.3 7.3 0 0 1 7.29-7.364z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.924 23.693a6.029 6.029 0 1 1-5.992 6.029 6.011 6.011 0 0 1 5.992-6.029z",
    fill: "#961b1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.924 24.052a5.67 5.67 0 1 1-5.633 5.67 5.661 5.661 0 0 1 5.633-5.67z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.77 19.882a5.937 5.937 0 0 1 3.489 5.357 6.213 6.213 0 0 1-6.443 5.974 6.213 6.213 0 0 1-6.443-5.974 5.965 5.965 0 0 1 3.682-5.412 8.662 8.662 0 0 1 5.643.101z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.591 24.944a4.833 4.833 0 0 1 0 .515c0 2.688-2.577 4.86-5.753 4.86s-5.771-2.172-5.771-4.86a4.262 4.262 0 0 1 .092-.847 7.115 7.115 0 0 1 11.433.331z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.876 24.42a3.525 3.525 0 0 1 2.264 3.148c0 1.951-1.841 3.535-4.188 3.535s-4.197-1.583-4.197-3.535a3.498 3.498 0 0 1 2.228-3.12 5.385 5.385 0 0 1 1.97-.359 5.744 5.744 0 0 1 1.924.331z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.648 26.104a5.173 5.173 0 0 1 2.761-1.381 23.344 23.344 0 0 0 .433 3.424c.396 2.043 1.022 3.415 1.915 3.415a4.602 4.602 0 0 0 2.062-.801s.221.138.423.92a4.234 4.234 0 0 1 .166 1.187 4.474 4.474 0 0 1-.506.451 4.998 4.998 0 0 1-2.66.865 3.452 3.452 0 0 1-3.332-2.412 27.615 27.615 0 0 1-1.261-5.67zm29.502-1.095a22.865 22.865 0 0 1 2.761.313l-1.5 5.146a7.53 7.53 0 0 0-.156 2.761 3.599 3.599 0 0 0 2.872 1.335 30.662 30.662 0 0 0 1.445-5.293l.497-3.074a10.632 10.632 0 0 1 2.375 1.169l.304-1.997a6.941 6.941 0 0 0-3.056-1.841 15.05 15.05 0 0 0-4.345-.856L33.15 25.01zm-7.465 1.62a5.992 5.992 0 1 1-5.992-5.992 6.011 6.011 0 0 1 5.992 5.992zm-4.013-1.049a3.028 3.028 0 1 0-3.028 3.047 3.038 3.038 0 0 0 3.028-3.047zm31.011 5.983a3.995 3.995 0 1 1-2.761-4.989 3.995 3.995 0 0 1 2.761 4.989zm-2.458-2.485a1.915 1.915 0 0 0-2.384 1.316 1.924 1.924 0 1 0 2.384-1.316z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFranceLotoPlus);
export default __webpack_public_path__ + "static/media/france_loto_plus.87d28668ccd1d0b7d691f4994edb6342.svg";
export { ForwardRef as ReactComponent };